/* istanbul ignore file */
/* tslint:disable */
 
import type { ContentTypeFull } from '../models/ContentTypeFull';
import type { Form } from '../models/Form';
import type { PaginatedDefaultFieldsList } from '../models/PaginatedDefaultFieldsList';
import type { PaginatedFormList } from '../models/PaginatedFormList';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class FormsService {

  /**
   * Adaptation of DRF ModelViewSet
   * @param action * `send_email` - send_email
 * * `save_client_response` - save_client_response
 * * `verify_recaptcha` - verify_recaptcha
 * * `verify_recaptcha_v3` - verify_recaptcha_v3
 * * `send_a_lead` - send_a_lead
 * * `send_a_lead_to_hrm` - send_a_lead_to_hrm
   * @param page A page number within the paginated result set.
   * @param pageSize Number of results to return per page.
   * @returns PaginatedFormList 
   * @throws ApiError
   */
  public static formsList(
action?: 'send_email' | 'save_client_response' | 'verify_recaptcha' | 'verify_recaptcha_v3' | 'send_a_lead' | 'send_a_lead_to_hrm',
page?: number,
pageSize?: number,
): CancelablePromise<PaginatedFormList> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/forms/',
      query: {
        'action': action,
        'page': page,
        'page_size': pageSize,
      },
    });
  }

  /**
   * Adaptation of DRF ModelViewSet
   * @param requestBody 
   * @returns Form 
   * @throws ApiError
   */
  public static formsCreate(
requestBody: Form,
): CancelablePromise<Form> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/forms/',
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * Adaptation of DRF ModelViewSet
   * @param id 
   * @returns Form 
   * @throws ApiError
   */
  public static formsRetrieve(
id: string,
): CancelablePromise<Form> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/forms/{id}',
      path: {
        'id': id,
      },
    });
  }

  /**
   * Adaptation of DRF ModelViewSet
   * @param id 
   * @param requestBody 
   * @returns Form 
   * @throws ApiError
   */
  public static formsUpdate(
id: string,
requestBody: Form,
): CancelablePromise<Form> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/forms/{id}',
      path: {
        'id': id,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * Adaptation of DRF ModelViewSet
   * @param id 
   * @returns void 
   * @throws ApiError
   */
  public static formsDestroy(
id: string,
): CancelablePromise<void> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/forms/{id}',
      path: {
        'id': id,
      },
    });
  }

  /**
   * Adaptation of DRF ModelViewSet
   * @param id 
   * @param page A page number within the paginated result set.
   * @param pageSize Number of results to return per page.
   * @param search Search term to filter responses across searchable fields
   * @param sortBy Field name to sort by. Prefix with '-' for descending order (e.g., '-created_at').
   * @returns PaginatedDefaultFieldsList 
   * @throws ApiError
   */
  public static formsResponsesList(
id: string,
page?: number,
pageSize?: number,
search?: string,
sortBy?: string,
): CancelablePromise<PaginatedDefaultFieldsList> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/forms/{id}/responses',
      path: {
        'id': id,
      },
      query: {
        'page': page,
        'page_size': pageSize,
        'search': search,
        'sort_by': sortBy,
      },
    });
  }

  /**
   * Export form responses to CSV format using Python's csv module
   * @param id 
   * @param exclude Comma-separated list of column names to exclude from export (e.g., 'id,created_at' or 'modified_at,created_by')
   * @param sortBy Field name to sort by. Prefix with '-' for descending order (e.g., '-created_at').
   * @returns Form 
   * @throws ApiError
   */
  public static formsResponsesExportCsvRetrieve(
id: string,
exclude?: string,
sortBy?: string,
): CancelablePromise<Form> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/forms/{id}/responses/export-csv',
      path: {
        'id': id,
      },
      query: {
        'exclude': exclude,
        'sort_by': sortBy,
      },
    });
  }

  /**
   * Export form responses to Excel format using openpyxl
   * @param id 
   * @param exclude Comma-separated list of column names to exclude from export (e.g., 'id,created_at' or 'modified_at,created_by')
   * @param sortBy Field name to sort by. Prefix with '-' for descending order (e.g., '-created_at').
   * @returns Form 
   * @throws ApiError
   */
  public static formsResponsesExportExcelRetrieve(
id: string,
exclude?: string,
sortBy?: string,
): CancelablePromise<Form> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/forms/{id}/responses/export-excel',
      path: {
        'id': id,
      },
      query: {
        'exclude': exclude,
        'sort_by': sortBy,
      },
    });
  }

  /**
   * @param codeName 
   * @returns ContentTypeFull 
   * @throws ApiError
   */
  public static formsDeliveryRetrieve(
codeName: string,
): CancelablePromise<ContentTypeFull> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/forms/delivery/{code_name}',
      path: {
        'code_name': codeName,
      },
    });
  }

  /**
   * @param codeName 
   * @returns Form 
   * @throws ApiError
   */
  public static formsDeliverySubmitCreate(
codeName: string,
): CancelablePromise<Form> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/forms/delivery/{code_name}/submit',
      path: {
        'code_name': codeName,
      },
    });
  }

}
